import { FunctionalComponent, h } from '@stencil/core';
import { AppMedia, AppLink } from './'

interface AppCard {
    Title: string;
    Page: any;
    Media: any;
}


export const AppCard: FunctionalComponent<AppCard> = ({ Title, Page, Media }) => {

    const Link = { page: Page };
    const hasMedia = Media && Media.data

    return (
        <div>
            <AppLink data={Link} className={`${hasMedia ? 'uk-height-medium@s uk-cover-container@s' : ''} uk-width-1-1 uk-link-reset uk-transition-toggle uk-inline uk-light`}>
                <AppMedia media={Media} className='uk-visible@s uk-width-1-1 uk-transition-scale-up uk-transition-opaque' size="(max-width: 638px) 90vh, (max-width: 958px) 50vw, 30vw" cover />
                <div class={`${hasMedia ? 'uk-background-angle-left@ns uk-position-bottom-right uk-position-relative@ns uk-width-1-1@ns uk-padding-left uk-padding-right uk-padding-small@ns uk-width-1-1@ns uk-background-primary-diag@s uk-background-default' : 'uk-padding-small uk-background-primary-diag uk-light uk-width-1-1'} uk-display-inline-block`}>
                    <h3 class={`${hasMedia ? 'uk-position-relative uk-heading-xsmall wsio-darker-green uk-padding-left-small uk-link-primary@ns' : 'uk-heading-small'} uk-flex uk-flex-center@s uk-flex-middle uk-button uk-button-link`}>{Title}<span class="bounce" uk-icon="icon:chevron-double-right;ratio:1.8"></span></h3>
                </div>
            </AppLink>
        </div>
    )
};